import React from 'react';
import './Link.css';

function Link({ url, title, mainImg, id }) {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="link" data-id={id}>
      {mainImg && <img src={mainImg} alt="" className="link-image" />}
      <span className="link-title">{title}</span>
    </a>
  );
}

export default Link;
